export default "__VITE_ASSET__bdd8a622__"